import React from 'react';
import Loading from '../Base/Loading';

function PageLoading() {
  return (
    <div className='flex h-[var(--screen)] w-screen items-center justify-center'>
      <Loading />
    </div>
  );
}

export default PageLoading;
